<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-checkbox`]" width="1em" height="1em" v-bind="$attrs"><rect x="3" y="3" width="18" height="18" rx="4" stroke="#165DFF" stroke-width="1.66" stroke-linejoin="round"/><path d="M6.89062 11.9134L9.22281 14.2456C9.61883 14.6416 9.81683 14.8396 10.0452 14.9138C10.246 14.9791 10.4624 14.9791 10.6632 14.9138C10.8915 14.8396 11.0895 14.6416 11.4855 14.2456L17.1081 8.62305" stroke="#00BBD8" stroke-width="1.66" stroke-linecap="round" stroke-linejoin="round"/></svg>
</template>
<script>

export default {
  name: 'IconColorCheckbox',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
